import { render } from "./SentimentPulseDashboard.vue?vue&type=template&id=30613b0b&scoped=true"
import script from "./SentimentPulseDashboard.vue?vue&type=script&lang=js"
export * from "./SentimentPulseDashboard.vue?vue&type=script&lang=js"

import "./SentimentPulseDashboard.vue?vue&type=style&index=0&id=30613b0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30613b0b"]])

export default __exports__